import { Button, message, Popconfirm } from 'antd'
import { useState } from 'react'

import { usePublicIpActions } from '@/hooks/usePublicIpActions'

interface Props {
  vmId: string
  ipLabel: string
  vmLabel: string
  disabled?: boolean
  onDetached: () => void
}

export function DetachPublicIpButton({
  vmId,
  ipLabel,
  vmLabel,
  disabled,
  onDetached,
}: Props) {
  const { detach } = usePublicIpActions()
  const [loading, setLoading] = useState(false)

  const handleConfirm = async () => {
    setLoading(true)
    try {
      await detach(vmId)
      onDetached()
    } catch (error) {
      if (error instanceof Error) void message.error(error.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Popconfirm
      title={`Detach ${ipLabel} from VM ${vmLabel}?`}
      description="The VM will lose this public IP. You can re-attach it later."
      okText="Detach"
      okButtonProps={{ danger: true }}
      onConfirm={handleConfirm}
      disabled={disabled}
    >
      <Button size="small" danger loading={loading} disabled={disabled}>
        Detach
      </Button>
    </Popconfirm>
  )
}
